import { Card, List, makeStyles } from '@material-ui/core';
import React from 'react';

import { ListItem, ListItemProps } from '../ListItem';

/**
 * CollapsibleListProps
 */
export interface CollapsibleListProps {
  /**
   * An array of list items to be displayed
   */
  listItems: ListItemProps[];
}

const useStyles = makeStyles(() => ({
  collapsibleListCard: {
    backgroundColor: 'white'
  }
}));

const CollapsibleList = ({ listItems }: CollapsibleListProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Card variant="outlined" className={classes.collapsibleListCard}>
      <List disablePadding>
        {listItems.map((listItem, idx) => (
          <ListItem key={idx} {...listItem} hasTitleDivider={idx < listItems.length - 1} />
        ))}
      </List>
    </Card>
  );
};

export { CollapsibleList };
